var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{tag:"component",attrs:{"text":_vm.text,"icon_name":_vm.icon_name}})
}
var staticRenderFns = []

export { render, staticRenderFns }